







































































































































//@ts-nocheck
//@ts-ignore
import { Component, Prop, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_avance_fisicos from '@/mixins/axios/poa_avance_fisicos'

//@ts-ignore
import poa_actividades_lineas_accion from '@/mixins/axios/poa_actividades_lineas_accion'
//@ts-ignore
import poa_capitulos_conacs from '@/mixins/axios/poa_capitulos_conacs'

//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {

  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
     

        id:null as any,

      poa_capitulos_conac_id:0,
     
     selectedvar:0,
         poa_capitulos_conacs:[] as any,
         
           planeado_1: null as any,
            planeado_2: null as any,
            planeado_3: null as any,
            planeado_4: null as any,              
            ejercido_1: null as any,
            ejercido_2: null as any,
            ejercido_3: null as any,
            ejercido_4: null as any,
 total_planeado: null as any,
            total_ejercido: null as any,
suma:null as any,


comentarios_1p:'' as any,
comentarios_2p:null as any,
comentarios_3p:null as any,
comentarios_4p:null as any,
comentarios_1e:null as any,
comentarios_2e:null as any,
comentarios_3e:null as any,
comentarios_4e:null as any,

comentario_active:null as any,
              poa_avance_fisicosdata:[] as any,
              poa_actividades_lineas_accion:{

            planeado_1: 0 as any,
            planeado_2: 0 as any,
            planeado_3: 0 as any,
            planeado_4: 0 as any,              
            ejercido_1: 0 as any,
            ejercido_2: 0 as any,
            ejercido_3: 0 as any,
            ejercido_4: 0 as any,
             total_planeado: 0 as any,
            total_ejercido: 0 as any,
             comentarios_1p:'' as any,
comentarios_2p:null as any,
comentarios_3p:null as any,
comentarios_4p:null as any,
comentarios_1e:null as any,
comentarios_2e:null as any,
comentarios_3e:null as any,
comentarios_4e:null as any,


              },
            capitulosConac:[] as any,
      
    }
  },
     mixins: [poa_avance_fisicos,poa_capitulos_conacs,poa_actividades_lineas_accion],
     validations: {
    
        /*   esperado_1: {
      required,
    },
      esperado_2: {
      required,
    },
      esperado_3: {
      required,
    },
      esperado_4: {
      required,
    },
      ejecutado_1: {
      required,
    },
      ejecutado_2: {
      required,
    },
      ejecutado_3: {
      required,
    },
      ejecutado_4: {
      required,
    },*/
      poa_capitulos_conac_id: {
      required,
    },

    


   
  },
  methods:{

     
    


     
     async GuardarData(){


       let dat={
avancesfisicos:[this.poa_actividades_lineas_accion],
poa_actividades_lineas_acciones_id:this.id
       }
let data= await this.CREAR_POA_AVANCE_FISICOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)


$('#modalCausa').modal('hide')
  //this.poa_avance_fisicosdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Avance Fisico, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
    
    async getData(id) {
  console.log(id,'----------lll----')
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
poa_actividades_lineas_acciones_id:id
};

let data= await this.GET_POA_AVANCE_FISICOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        if(response.hasOwnProperty('id')){

this.poa_actividades_lineas_accion=response;

                        }

                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},


  },
  mounted(){  
    this.getData(this.id);
      //this.getDataCapituloCONAC();//this.getData();
    
      //this.getDataLineaAccion();
  }
})
export default class Home extends Vue {

    @Prop() private id !:any;
     @Prop() private des !:any;
}

